import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button, Select} from 'antd'
import forumlaInfoAPI from '../../apis/forumlaInfo'
import Axios from 'axios'
import {Base64} from 'js-base64'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

class FormModal extends Component {
  formRef = React.createRef()

  state = {
    formulaTypeIdOption: []
  }

  componentDidMount() {
    const {id} = this.props
    let _this = this
    Axios.all([forumlaInfoAPI.getFormulaTypeAction(), forumlaInfoAPI.getAction(id)]).then(Axios.spread(function (_getFormulaTypeAction, _getAction) {
      let result = _getAction.data.data
      _this.formRef.current.setFieldsValue({
        name: result.name,
        examples: result.examples,
        description: result.description,
        formulaTypeId: result.formulaTypeId,
        importClass: result.importClass,
        groovyScript: result.groovyScript
      })
      _this.setState({
        formulaTypeIdOption: _getFormulaTypeAction.data.data
      })
    }))
  }

  handleOk = () => {
    const {handleCancel, handleSearch, id} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        id,
        name: fieldsValue.name,
        examples: fieldsValue.examples,
        description: fieldsValue.description,
        formulaTypeId: fieldsValue.formulaTypeId,
        importClass: Base64.encode(fieldsValue.importClass),
        groovyScript: Base64.encode(fieldsValue.groovyScript)
      }
      forumlaInfoAPI.addAction(params).then(res => {
        handleCancel('editModalVisible')
        handleSearch()
      })

    }).catch(err => { })
  }

  render() {
    const {editModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.edit`)} ${t(`formulaInfo.formulaInfo`)}`}
          closable={true}
          onCancel={() => { handleCancel('editModalVisible') }}
          width="70%"
          visible={editModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => { handleCancel('editModalVisible') }}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 0]}>
              <Col span={12}>
                <Form.Item name="name" label={t(`formulaInfo.name`)}
                           rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.name`)}`, pattern: new RegExp(/\S/)}]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="formulaTypeId" label={t(`formulaInfo.formulaType`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`formulaInfo.formulaType`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    {
                      this.state.formulaTypeIdOption.map((e, i) => {
                        return (
                          <Select.Option key={e.id} value={e.id}>{e.name}</Select.Option>
                        )
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="examples" label={t(`formulaInfo.examples`)}
                           rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.examples`)}`, pattern: new RegExp(/\S/)}]}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="description" label={t(`formulaInfo.description`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.description`)}`,
                             pattern: new RegExp(/\S/)
                           }]}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="importClass" label={t(`formulaInfo.importClass`)}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="groovyScript" label={t(`formulaInfo.groovyScript`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`formulaInfo.groovyScript`)}`,
                             pattern: new RegExp(/\S/)
                           }]}>
                  <TextArea rows={5}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
